import { render, staticRenderFns } from "./tenderProMgmt.vue?vue&type=template&id=07bb3ec1&scoped=true"
import script from "./tenderProMgmt.vue?vue&type=script&lang=js"
export * from "./tenderProMgmt.vue?vue&type=script&lang=js"
import style0 from "./tenderProMgmt.vue?vue&type=style&index=0&id=07bb3ec1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb3ec1",
  null
  
)

export default component.exports